import { compose, createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { createAnalyticsReporter, createCrashReporter, createErrorReporter } from '@cx/analytics/redux'
import IS_CLIENT from '../utils/is-client'
import rootReducer from './reducers/root-reducer'
import analyticsTracker from '../utils/analytics-tracker'

const analyticsMiddleware = []

if (IS_CLIENT) {
  analyticsMiddleware.push(createCrashReporter(analyticsTracker), createAnalyticsReporter(analyticsTracker), createErrorReporter(analyticsTracker))
}

export default (initialState, fetchMethod) => {
  const enhancer = compose(
    applyMiddleware(...[thunk.withExtraArgument(fetchMethod), ...analyticsMiddleware]),
    IS_CLIENT && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f
  )

  const store = createStore(rootReducer, initialState, enhancer)

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers/root-reducer', () => {
      /* eslint-disable global-require */
      const nextRootReducer = require('./reducers/root-reducer').default
      store.replaceReducer(nextRootReducer)
    })
  }

  return store
}
